/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  DRAFT_POST: 'DRAFT_COMPOSE_EXPERIENCE',
  PUT: 'UPDATE_COMPOSE_EXPERIENCE',
  DELETE: 'DELETE_COMPOSE_EXPERIENCE',
  RESET: 'RESET_COMPOSE_EXPERIENCE',
  RELOAD: 'RELOAD_COMPOSE_EXPERIENCE',
};

export const getDraftId = () => '';

export const composeExperienceReducer = (state = [], action) => {
  switch (action.type) {
    case types.DRAFT_POST:
      return [
        ...state,
        { ...action.payload },
      ];
    case types.PUT:
      console.log(state)
      return state.map((child) => (child.id == action.payload.id ? action.payload : child));
    case types.DELETE:
      const newValues = [...state];
      const index = newValues.indexOf(action.item);
      newValues.splice(index, 1);
      return newValues;
    case types.RELOAD:
      return action.payload;
    case types.RESET:
      return [];
    default:
      return state;
  }
};
